import { Bell, Home, Search, Shield, Tags } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import { IconButton } from '@/components/ui/IconButton';
import { cn } from '@/utils/cn';

const navItems = [
  { to: '/', label: 'Feed', icon: Home },
  { to: '/buscar', label: 'Buscar', icon: Search },
  { to: '/categorias', label: 'Categorias', icon: Tags },
  { to: '/admin', label: 'Admin', icon: Shield }
];

export function AppLayout() {
  return (
    <div className="min-h-dvh bg-divergent-black text-divergent-white">
      <header className="fixed inset-x-0 top-0 z-40 border-b border-white/10 bg-black/80 backdrop-blur-xl">
        <div className="safe-px mx-auto flex h-14 max-w-app items-center justify-between">
          <NavLink to="/" className="flex items-center gap-2" aria-label="El Divergente">
            <span className="grid size-9 place-items-center rounded bg-divergent-yellow font-black text-black">
              ED
            </span>
            <span className="text-sm font-semibold uppercase tracking-[0.14em]">El Divergente</span>
          </NavLink>
          <IconButton label="Ultimo momento" icon={Bell} />
        </div>
      </header>

      <main className="mx-auto min-h-dvh max-w-app pt-14">
        <Outlet />
      </main>

      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-black/85 backdrop-blur-xl">
        <div className="safe-px safe-pb mx-auto grid max-w-app grid-cols-4 pt-2">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                cn(
                  'flex min-h-12 flex-col items-center justify-center gap-1 text-[11px] text-white/55 transition',
                  isActive && 'text-divergent-yellow'
                )
              }
            >
              <Icon size={20} aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
